import React from 'react';
import Header from "./Header";
import Features from "./Description";

export default ({data})=>{
  
    return (
      <React.Fragment>
         <Header data={data} />
         <Features data={data} />

      </React.Fragment>
    
    )
}